import { useContext } from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import MaccsProfilePage from '../../Components/MACCS/ProfilePage/MaccsProfilePage'
import AssistantsView from '../../Views/MACCS/Assistants/AssistantsView'
import SpecialitiesView from '../../Views/MACCS/Specialities/SpecialitiesView'
import MaccsInstitutionsView from '../../Components/MACCS/Institutions/MaccsInstitutionsView'
import MaccsSchoolSettingsView from '../../Views/shared/Settings/MaccsSchoolSettingsView'
import MaccsShiftManagerView from '../../Views/MACCS/ShiftsManager/MaccsShiftsManagerView'
import { GlobalContext } from '../../Providers/GlobalProvider'
import AssistantsReportingView from '../../Views/AssistantReportingView'
import { isMoment } from 'moment'
import { Routes } from '../../routes'
import MaccsInternshipsCalendar from '../../Views/MACCS/MaccsInternshipsManager/MaccsInternshipsCalendar'
import MaccsInternshipsProvider from '../../Providers/MaccsInternshipsProvider'
import MaccsInternshipMessageProvider from '../../Providers/MaccsinternshipMessageProvider'
import ContactPersons from '../../Views/MACCS/ContactPersons/ContactPersons'

const MaccsSchoolRouter = ({ history, onLogout }) => {
  const { setCurrentDate } = useContext(GlobalContext)

  const goToShiftManager = date => {
    history.push(Routes.SHIFTS_MANAGER)

    if (isMoment(date)) {
      setCurrentDate(date)
    }
  }

  return (
    <MaccsInternshipMessageProvider>
      <Switch>
        <Route path={Routes.INTERNSHIPS}>
          <MaccsInternshipsProvider>
            <MaccsInternshipsCalendar loadShiftsManager={goToShiftManager} />
          </MaccsInternshipsProvider>
        </Route>
        <Route path={Routes.SHIFTS_MANAGER}>
          <MaccsShiftManagerView />
        </Route>
        <Route path={Routes.PROFILE_PAGE}>
          <MaccsProfilePage onLogout={onLogout} />
        </Route>
        <Route path={Routes.ASSISTANTS}>
          <AssistantsView />
        </Route>
        <Route path={Routes.SPECIALITIES}>
          <SpecialitiesView />
        </Route>
        <Route path={Routes.INSTITUTIONS}>
          <MaccsInstitutionsView />
        </Route>
        <Route path={Routes.SETTINGS}>
          <MaccsSchoolSettingsView />
        </Route>
        <Route path={Routes.CONTACT_PERSONS}>
          <ContactPersons />
        </Route>
        <Route path={Routes.BADGES}>
          <AssistantsReportingView />
        </Route>
      </Switch>
    </MaccsInternshipMessageProvider>
  )
}

export default withRouter(MaccsSchoolRouter)
